import React, { useEffect, useState } from "react";
import { Novedad } from "./Novedad";
import ReactHtmlParser from "react-html-parser";

export const NovedadesHome = () => {
    const [novedades, setNovedades] = useState([]);

    const _novedades = novedades.map(novedad => {
        const year = novedad.created_at.substr(0, 4);
        const month = novedad.created_at.substr(5, 2);
        const day = novedad.created_at.substr(8, 2);
        const months = [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre"
        ];

        return {
            ...novedad,
            created_at: `${day} de ${months[+month - 1]} ${year}`
        };
    });

    useEffect(() => {
        fetch("/getNovedades")
            .then(res => res.json())
            .then(result => {
                if (result.estado !== 0) {
                    setNovedades(result);
                }
            });
    }, []);
    // if (!novedades.id%2 == 1){
    //     return <div className="separator--ver separator--ver--black mt-half mb-octa"></div>
    // }
    if (!novedades.length)
        return (
            <div className="d-flex flex-column w-100 justify-content-center align-items-center">
                <p className="mt-2">Actualizando Novedades</p>
                <div
                    className="spinner-border text-rojo mb-half"
                    role="status"
                >
                </div>
            </div>
        );


    // return <div className="separator--ver separator--ver--black mt-half mb-octa"></div>

    return (
        <div className="novedadesHome">
            <div className="novedadesHome--container">
                <h1 className="title30 mb-xl-base">novedades</h1>
                <div className="novedades_group">
                    {_novedades.map(novedad => (
                        <Novedad
                            key={novedad.id}
                            title={novedad.titulo}
                            date={novedad.created_at}
                            id={novedad.id ? novedad.id : null}
                            pdf={
                                novedad.hash_archivo
                                    ? `downloadFile/${novedad.id}/${novedad.hash_archivo}`
                                    : null
                            }
                            img={
                                novedad.foto
                                    ? `/storage/novedades/${novedad.id}/${novedad.hash_foto}`
                                    : null
                            }
                            link={novedad.link ? `${novedad.link}` : null}
                            interna={
                                novedad.link ? null : `/novedades/${novedad.id}`
                            }
                            btn={
                                novedad.nombre_boton_link
                                    ? `${novedad.nombre_boton_link}`
                                    : null
                            }
                            descripcion={
                                novedad.descripcion
                                    ? `${novedad.descripcion}`
                                    : null
                            }
                        >
                            <p className="text">
                                {ReactHtmlParser(novedad.leyenda)}
                            </p>
                        </Novedad>
                    ))}
                </div>
            </div>
        </div>
    );
};
